import { render } from "./Rangpur.vue?vue&type=template&id=ed2e0a66"
import script from "./Rangpur.vue?vue&type=script&lang=js"
export * from "./Rangpur.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__